export const TMS_AUTH_TOKEN_NAME = 'tms_auth_token';
export const ACP_AUTH_TOKEN_NAME = 'acp_auth_token';
const AUTH_TOKEN_NAMES = {
    TMS: TMS_AUTH_TOKEN_NAME,
    ACP: ACP_AUTH_TOKEN_NAME,
};
export function getAuthToken(appName) {
    const storedToken = localStorage.getItem(AUTH_TOKEN_NAMES[appName]);
    if (storedToken) {
        return JSON.parse(storedToken);
    }
    return null;
}
export function clearAuthToken(appName) {
    localStorage.removeItem(AUTH_TOKEN_NAMES[appName]);
}
export function setAuthToken(appName, token) {
    localStorage.setItem(AUTH_TOKEN_NAMES[appName], JSON.stringify(token));
}
/**
 * Helper function to check if token is expired
 * @param token - token to check
 * @returns 0 if token is expired, 1 if token is nearly expired, 2 if token is alive
 */
export function checkTokenExpirationStatus(token) {
    const EXPIRATION_RENEWAL_TIME = 10 * 60 * 1000; // 10 mins
    const expiredDate = new Date(token.expires);
    const now = new Date();
    const expiredTime = expiredDate.getTime();
    const nowTime = now.getTime();
    // token is not expired
    if (expiredTime > nowTime) {
        // renew token when nearly expired
        if (expiredTime - EXPIRATION_RENEWAL_TIME < nowTime) {
            return 1; // nearly expired
        }
        else {
            return 2; // token is alive
        }
    }
    else {
        // expired token
        return 0;
    }
}
export function checkIsUserLoggedIn(appName) {
    const token = getAuthToken(appName);
    if (token) {
        const tokenAlive = checkTokenExpirationStatus(token);
        if (tokenAlive === 0) {
            clearAuthToken(appName);
            return false;
        }
        else {
            return true;
        }
    }
    else {
        return false;
    }
}
/**
 * Type guard to check if the response is a 2 factor authentication response
 */
export function isAuth2FactorResponseGuard(response) {
    return response.need_verification === true;
}
